import { render, staticRenderFns } from "./NuovoQuestionario.vue?vue&type=template&id=effb60d2&"
import script from "./NuovoQuestionario.vue?vue&type=script&lang=js&"
export * from "./NuovoQuestionario.vue?vue&type=script&lang=js&"
import style0 from "./NuovoQuestionario.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports